// Split typography: CALL (white) + SHEET (silver default | gold marketing).
// Programmatic brand mark per brand book.
export default function BrandName({
  variant = "silver",     // "silver" | "gold"
  size = "md",            // "sm" | "md" | "lg" | "xl" | "hero"
  className = "",
  withClapper = false,
  withTagline = false,
}) {
  const sizes = {
    sm:   "text-xl",
    md:   "text-3xl",
    lg:   "text-5xl",
    xl:   "text-6xl md:text-7xl",
    hero: "text-6xl sm:text-7xl md:text-8xl lg:text-9xl",
  };
  const sheetColor = variant === "gold" ? "#F5B82E" : "#C0C0C0";

  return (
    <div className={`inline-flex flex-col items-start ${className}`} data-testid="brand-name">
      <div className="inline-flex items-center gap-3">
        {withClapper && (
          <span className="relative h-[1em] w-[1.05em] inline-block align-middle" aria-hidden>
            <span className="absolute inset-x-0 bottom-0 h-[68%] bg-[#0a0a0a] border border-white/30 rounded-sm" />
            <span className="absolute inset-x-0 top-0 h-[36%] origin-bottom-left -rotate-[12deg] cs-clapper-stripes rounded-sm" />
          </span>
        )}
        <span
          className={`font-display font-bold uppercase tracking-tighter leading-none ${sizes[size]}`}
        >
          <span style={{ color: "#FFFFFF" }}>CALL</span>
          <span style={{ color: sheetColor, marginLeft: "0.18em",
                          textShadow: variant === "silver"
                            ? "0 1px 0 rgba(255,255,255,0.15), 0 2px 4px rgba(0,0,0,0.6)"
                            : "0 0 30px rgba(245,184,46,0.35)" }}>
            SHEET
          </span>
        </span>
      </div>
      {withTagline && (
        <div className="mt-3 text-[0.62rem] sm:text-xs tracking-[0.28em] uppercase"
             style={{ color: "#F5B82E" }}>
          Digital Identity of Entire Media and Film Spectrum
        </div>
      )}
    </div>
  );
}
